!function ($, global) {
    'use strict';

    var isMobile = /mobi/i.test(global.navigator.userAgent);

    var EVENT_MOUSEOVER = 'mouseover';
    var EVENT_MOUSELEAVE = 'mouseleave';

    var TOGGLE_HIGHLIGHT_CLASS = 'state-highlight';
    var TOGGLE_HOVER_CLASS = 'state-hover';
    var TOGGLE_ACTIVE_CLASS = 'state-active';

    var $navbar = $('.navbar');
    var $toggles = $('[data-toggle]');

    function handleToggleClass($toggle, className, $caster, addEventName, removeEventName) {
        $caster
            .on(addEventName, function () {
                $toggle.addClass(className);
            })
            .on(removeEventName, function () {
                $toggle.removeClass(className);
            });
    }

    if (!isMobile) {
        handleToggleClass($toggles, TOGGLE_HIGHLIGHT_CLASS, $navbar, EVENT_MOUSEOVER, EVENT_MOUSELEAVE);
    }

    $toggles.each(function () {
        var $toggle = $(this);
        var $target = $($toggle.data('target'));
        var type = $toggle.data('toggle');

        if (!isMobile) {
            handleToggleClass($toggle, TOGGLE_HOVER_CLASS, $toggle, EVENT_MOUSEOVER, EVENT_MOUSELEAVE);
        }

        if (type === 'modal') {
            handleToggleClass($toggle, TOGGLE_ACTIVE_CLASS, $target, 'show.bs.' + type, 'hidden.bs.' + type);
        } else if (type === 'collapse') {
            handleToggleClass($toggle, TOGGLE_ACTIVE_CLASS, $target, 'show.bs.' + type, 'hide.bs.' + type);
        }
    });
}(jQuery, window);